var AudienceFilterDataType = /* @__PURE__ */ ((AudienceFilterDataType2) => {
  AudienceFilterDataType2["Unspecified"] = "Unspecified";
  AudienceFilterDataType2["String"] = "String";
  AudienceFilterDataType2["Boolean"] = "Boolean";
  AudienceFilterDataType2["Integer"] = "Integer";
  AudienceFilterDataType2["Version"] = "Version";
  return AudienceFilterDataType2;
})(AudienceFilterDataType || {});
var AudienceFilterOperator = /* @__PURE__ */ ((AudienceFilterOperator2) => {
  AudienceFilterOperator2["In"] = "In";
  return AudienceFilterOperator2;
})(AudienceFilterOperator || {});
export {
  AudienceFilterDataType,
  AudienceFilterOperator
};
//# sourceMappingURL=AudienceFilterModels.js.map
